export const FETCH_AUDIT_LOGS_REQUEST = "FETCH_AUDIT_LOGS_REQUEST";
export const FETCH_AUDIT_LOGS_SUCCESS = "FETCH_AUDIT_LOGS_SUCCESS";
export const FETCH_AUDIT_LOGS_FAILURE = "FETCH_AUDIT_LOGS_FAILURE";

export const SEARCH_AUDIT_LOGS_REQUEST = "SEARCH_AUDIT_LOGS_REQUEST";
export const SEARCH_AUDIT_LOGS_SUCCESS = "SEARCH_AUDIT_LOGS_SUCCESS";
export const SEARCH_AUDIT_LOGS_FAILURE = "SEARCH_AUDIT_LOGS_FAILURE";
